// const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';
const uuid = require('uuid');

const _ = {
    find:       require('lodash/find'),
    map:        require('lodash/map'),
};

const Strings = require('../../../../app/shared/Strings');

const ShortCourseActions = require('../../actions/ShortCourseActions');

const AssetUtil = require('../../util/asset');
import SingleAssetInput from '../common/SingleAssetInput';
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    courseHash: PropTypes.string.isRequired,
    options: PropTypes.object.isRequired,
    onChangeOptions: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
};

class CourseCardEditorModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            course_img: props.options.course_img || '',
            purchase_img: props.options.purchase_img || '',
            courseSummary: props.options.courseSummary || '',
            arrWhatYouWillLearn: props.options.arrWhatYouWillLearn || [''], // array of strings
            activityCount: props.options.activityCount || 0,
            taskCount: props.options.taskCount || 0,
            whoIsThisFor: props.options.whoIsThisFor || '',
        };
    }
    
    updateImage=(key, assetParams, files)=>{
        const imageUpdateActionID = uuid.v4();
        let params = {...assetParams, 
            courseHash: this.props.courseHash,
            asset_name: `course card ${key} image`
        };
        this.setState({ imageUpdateActionID },()=>{
            // after updating state, upload the image
            ShortCourseActions.addShortCourseVersionAsset(imageUpdateActionID, params, files, (asset_url)=>{
                // after uploading the image, set the url
                this.setState({
                    [key]:asset_url
                });
            });
        });
    }

    updateImageOnError=(errorMsg)=>{
        window.alert(errorMsg || 'Error');
    }
    
       
    onTextChange=(key,e)=>{
        this.setState({[key]: e.target.value });
    }
    
    onNumberChange=(key,e)=>{
        this.setState({[key]: e.target.value });
    }
    
    onArrayElemChange=(key,index,e)=>{
        let arr = this.state[key].slice();
        arr[index] = e.target.value;
        this.setState({[key]: arr });
    }
    
    deleteArrayElem=(key,index)=>{
        let arr = this.state[key].slice();
        arr.splice(index,1);
        this.setState({[key]: arr });
    }

    addArrayElem=(key)=>{
        let arr = this.state[key].slice();
        arr.push('');
        this.setState({[key]: arr });
    }
    
    saveOptions=()=>{
        this.props.onChangeOptions({
            course_img: this.state.course_img,
            purchase_img: this.state.purchase_img,
            courseSummary: this.state.courseSummary,
            arrWhatYouWillLearn: this.state.arrWhatYouWillLearn,
            activityCount: Number(this.state.activityCount),
            taskCount: Number(this.state.taskCount),
            whoIsThisFor: this.state.whoIsThisFor
        });
        this.props.closeHandler();
    }

    render() {
        return (
            <Modal
                dialogClassName="course-card-modal"
                show={true}
                keyboard
                autoFocus
                enforceFocus={false}
                restoreFocus={false}
                backdrop={false}
                animation={false}
                onHide={this.props.closeHandler}
                aria-labelledby="course-card-title"
            >
                <Modal.Header closeButton closeLabel={Strings['en'].common.CLOSE} onHide={this.props.closeHandler}>
                    <Modal.Title id="course-card-title">{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="course-card-body">
                        <div className="edit-selector">
                            <label>{Strings['en'].course_purchase_page.COURSE_SUMMARY  + ':'}</label>
                            <input type='text' value={this.state.courseSummary} onChange={this.onTextChange.bind(this,'courseSummary')}/>
                        </div>
                        <div className="col-12 edit-selector image-columns">
                            <div className="col-6 image-column">
                                <label className="image-label">{Strings['en'].course_purchase_page.COURSE_CARD_IMAGE  + ':'}</label>
                                <SingleAssetInput
                                    buttonOnly
                                    browseText="Upload Image"
                                    assetType="image"
                                    assetRole="normal"
                                    accept="image/*"
                                    onChange={this.updateImage.bind(this,'course_img')}
                                    onError={this.updateImageOnError}
                                    validateAssetType={AssetUtil.validateImageMimeType}
                                    disabled={!!this.state.imageUpdateActionID}
                                />
                                {this.state.course_img ? 
                                <img className="card-image" src={AssetUtil.resolveAssetPath(this.state.course_img)}/>
                                : null }
                            </div>
                            <div className="col-6 image-column">
                                <label className="image-label">{Strings['en'].course_purchase_page.COURSE_PURCHASE_IMAGE  + ':'}</label>
                                <SingleAssetInput
                                    buttonOnly
                                    browseText="Upload Image"
                                    assetType="image"
                                    assetRole="normal"
                                    accept="image/*"
                                    onChange={this.updateImage.bind(this,'purchase_img')}
                                    onError={this.updateImageOnError}
                                    validateAssetType={AssetUtil.validateImageMimeType}
                                    disabled={!!this.state.imageUpdateActionID}
                                />
                                {this.state.purchase_img ?
                                <img className="card-image" src={AssetUtil.resolveAssetPath(this.state.purchase_img)}/>
                                : null }
                            </div>
                        </div>
                        
                        <div className="edit-section">
                            <h2 className="section-title" >{Strings['en'].course_purchase_page.WHAT_YOULL_LEARN  + ':'}</h2>
                            { _.map(this.state.arrWhatYouWillLearn,(txt,index)=>(
                            <div className="edit-selector" key={index}>
                                <label className="array-label">{`${index+1}`}</label>
                                <input className="array-item" type='text' value={this.state.arrWhatYouWillLearn[index]} onChange={this.onArrayElemChange.bind(this,'arrWhatYouWillLearn',index)}/>
                                <button className="delete-line-button" title="delete line" onClick={this.deleteArrayElem.bind(this,'arrWhatYouWillLearn',index)}>
                                    <AccessibleIcon className="fa fa-trash" label="delete line"/>
                                </button>
                            </div>
                            ))}
                            <button className="add-line-button" title="add line" onClick={this.addArrayElem.bind(this,'arrWhatYouWillLearn')}>
                                <AccessibleIcon className="fa fa-plus" label="add line"/>
                            </button>
                        </div>
                        <div className="number-section">
                            <h2 className="section-title">{Strings['en'].course_purchase_page.WHAT_THIS_COURSE_INCLUDES  + ':'}</h2>
                            <div className="edit-selector">
                                <label>{Strings['en'].course_purchase_page.ASSIGNMENTS  + ':'}</label>
                                <input type='number' value={this.state.activityCount} onChange={this.onNumberChange.bind(this,'activityCount')}/>
                            </div>
                            <div className="edit-selector">
                                <label>{Strings['en'].course_purchase_page.TASKS  + ':'}</label>
                                <input type='number' value={this.state.taskCount} onChange={this.onNumberChange.bind(this,'taskCount')}/>
                            </div>
                        </div>
                        <div className="edit-selector">
                            <label>{Strings['en'].course_purchase_page.WHO_IS_THIS_COURSE_FOR  + ':'}</label>
                            <input type='text' value={this.state.whoIsThisFor} onChange={this.onTextChange.bind(this,'whoIsThisFor')}/>
                        </div>

                        <button className="btn btn-primary update-button" title={Strings['en'].common.UPDATE} disabled={false} onClick={this.saveOptions}>
                            {Strings['en'].common.UPDATE}
                        </button>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        );
    } // render
}; // CourseCardEditorModal

CourseCardEditorModal.propTypes = propTypes;
CourseCardEditorModal.defaultProps = defaultProps;

export default CourseCardEditorModal;